import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Beta from "./Beta";
import PrivacyNotice from "./PrivacyNotice";
import "./styles/responsive.css";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/beta" element={<Beta />} />
      <Route path="/privacy" element={<PrivacyNotice />} />
    </Routes>
  );
}
